import { getStorage } from 'utils/utils';

export enum Step {
    PRODUCT_HOME = 'PRODUCT_HOME',
    ANALYSE = 'ANALYSE',
    BALCAO = 'BALCAO',
    DIRETO = 'DIRETO',
    FLOW_FINISHED = 'FLOW_FINISHED',
    BIZON = 'BIZON',
};

const LOCAL_STEP = 'LOCAL_STEP';

export const initStep = (step: Step) => {
    if (!getStep()) {
        setStep(step);
    }
}

export const getStep = () => {
    return getStorage().getItem(LOCAL_STEP) as Step;
}

export const setStep = (step: Step) => {
    getStorage().setItem(LOCAL_STEP, step);
}

export const nextStep = () => {
    const currentStep = getStep();

    if (currentStep === Step.DIRETO) {
        setStep(Step.ANALYSE);
    }

    if (currentStep === Step.ANALYSE) {
        setStep(Step.BALCAO);
    }

    if (currentStep === Step.BALCAO) {
        setStep(Step.BIZON);
    }
}
